export default "__VITE_ASSET__Ck6NOwZL__"